import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss'; // Reusing the same SCSS for consistency
import { ReactComponent as General_athletic_performanceIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_athletic_performance.svg';
import { ReactComponent as Crossfit_style_trainingIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/crossfit_style_training.svg';
import { ReactComponent as Power_liftingIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/power_lifting.svg';
import { ReactComponent as Combat_sportsIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/combat_sports.svg';
import { ReactComponent as FootballIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/football.svg';
import { ReactComponent as RunningIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/performance-running.svg';
import { ReactComponent as TennisIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/tennis.svg';
import { ReactComponent as CyclingIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cycling.svg';

interface PerformanceStep1Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  running: <RunningIcon />,
  cycling: <CyclingIcon />,
  swimming: null, // SVG not provided in assets
  powerlifting: <Power_liftingIcon />,
  football: <FootballIcon />,
  tennis: <TennisIcon />,
  combat_sports: <Combat_sportsIcon />,
  general_athletic_performance: <General_athletic_performanceIcon />,
  crossfit_style_training: <Crossfit_style_trainingIcon />,
};

// What type of performance should this program support?
export const PerformanceStep1: FC<PerformanceStep1Props> = ({ value, onNext }) => {
  const [selectedSupport, setSelectedSupport] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalDetails?.groups?.find(
    (g: any) => g.goalId === 'performance',
  );

  const supports = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>

      <div className="goal-buttons">
        {supports.map((support: any) => (
          <button
            key={support.id}
            className={`goal-btn ${selectedSupport === support.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedSupport(support.slug);
              if (onNext) onNext(support.slug);
            }}
          >
            <div className="goal-icon">{iconMap[support.id]}</div>
            <span className="goal-label">{support.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
